import styled from 'styled-components';
import { ClearIcon } from '../../svg';
import { colors } from '../../constants';

interface IProps {
    className?: string;
    onClick(): void;
}

const BaseClearButton = ({ className, onClick }: IProps) => (
    <div className={className} role="button" onClick={onClick}>
        <ClearIcon />
    </div>
);

export const ClearButton = styled(BaseClearButton)`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 1.75rem;
    width: 1.75rem;
    cursor: pointer;
    background-color: ${colors.greyBorder};
    border-radius: 50%;
    color: #fff;

    ${ClearIcon} {
        display: inline-block;
        vertical-align: middle;
    }

    &:hover {
        background-color: ${colors.greyDark};
    }
`;
